module.exports = __webpack_public_path__ + "static/media/ehealth_pro_noti_tips_step_3.a6d1d7dc.png";